import * as React from 'react';
import {
    IconButton,
    InputAdornment,
} from '@mui/material';
import {
    StandardTextField
} from "@jeremyling/react-material-ui-form-builder";
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';



const PasswordField = (field, methods, f) => {
    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };



    const fieldConfig = React.useMemo(() => {
        return {
            ...field,
            props: {
                ...field.props,
                type: showPassword ? 'text' : 'password',
                InputProps: {
                    endAdornment: <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            edge="end"
                            size={"large"}
                        >
                            {showPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                        </IconButton>
                    </InputAdornment>
                }
            }
        }
    }, [showPassword]);

    return <StandardTextField field={fieldConfig} methods={methods} />
}

export default PasswordField;